module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', _vm._l((_vm.posts), function(post) {
    return _c('only-post', {
      key: post.title,
      staticClass: "animated",
      class: _vm.themeCfg.animated && _vm.themeCfg.animated.posts,
      attrs: {
        "post": post
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61377d63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Posts.vue
// module id = 155
// module chunks = 1